/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Nav_IdeasInputs */

const en_zombie_nav_ideas = /** @type {(inputs: Zombie_Nav_IdeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideas`)
};

const zh_zombie_nav_ideas = /** @type {(inputs: Zombie_Nav_IdeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创意`)
};

/**
* | output |
* | --- |
* | "Ideas" |
*
* @param {Zombie_Nav_IdeasInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_nav_ideas = /** @type {((inputs?: Zombie_Nav_IdeasInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Nav_IdeasInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_nav_ideas(inputs)
	return zh_zombie_nav_ideas(inputs)
});
export { zombie_nav_ideas as "zombie.nav.ideas" }